import { useAuth } from "@/lib/auth";

const ALLOWED_DOMAIN = import.meta.env.VITE_ALLOWED_DOMAIN ?? "artefact.com";

export function AccessDenied() {
  const { user, signOut } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="w-full max-w-md space-y-4 rounded-lg border bg-card p-8 shadow-sm text-center">
        <h1 className="text-xl font-semibold">Access denied</h1>
        <p className="text-sm text-muted-foreground">
          {user?.email ? (
            <>
              <code>{user.email}</code> isn't a member of the <code>{ALLOWED_DOMAIN}</code> Google
              Workspace.
            </>
          ) : (
            <>
              Your Google account isn't a member of the <code>{ALLOWED_DOMAIN}</code> Workspace.
            </>
          )}
        </p>
        <p className="text-sm text-muted-foreground">
          Sign in with your <code>@{ALLOWED_DOMAIN}</code> work account, or ping the arena team if
          you believe this is wrong.
        </p>
        <button
          type="button"
          onClick={signOut}
          className="rounded-md border px-3 py-1.5 text-sm hover:bg-accent"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
